var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 d-flex justify-content-center",attrs:{"id":"ngo-forum"}},[_c('div',{staticClass:"card my-5"},[_c('div',{staticClass:"card-body"},[_c('h1',{staticClass:"font-weight-bold text-primary text-uppercase"},[_vm._v("coming soon")])])])])
}]

export { render, staticRenderFns }